<ng-form class="k-form k-form-md" [formGroup]="rcForm">
    <fieldset>
        <legend style="border-bottom: 1px solid #e2e8f0;">Roller Cone Parameters</legend>
        <div class="row">
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="rcBitCode">Bit Code</kendo-label>
                    <kendo-textbox formControlName="bitCode" id="rcBitCode"
                        [readonly]="readonly"></kendo-textbox>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="rcBitClass">Bit Class</kendo-label>
                    <kendo-textbox formControlName="bitClass" id="rcBitClass"
                        [readonly]="readonly"></kendo-textbox>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="rcConeType">Cone Type</kendo-label>
                    <kendo-textbox formControlName="coneType" id="rcConeType"
                        [readonly]="readonly"></kendo-textbox>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="rcBrgCode">Bearing Code</kendo-label>
                    <kendo-textbox formControlName="brgCode" id="rcBrgCode"
                        [readonly]="readonly"></kendo-textbox>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="rcTaskLevel">Task Level</kendo-label>
                    <kendo-dropdownlist formControlName="taskLevel" id="rcTaskLevel"
                        [data]="taskLevelOptions" textField="name" valueField="id"
                        [valuePrimitive]="true" [readonly]="readonly">
                    </kendo-dropdownlist>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="rcShirtTailProtection">Shirt Tail Protection</kendo-label>
                    <kendo-textbox formControlName="shirtTailProtection" id="rcShirtTailProtection"
                        [readonly]="readonly"></kendo-textbox>
                </kendo-formfield>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="rcPinAng">Pin Angle</kendo-label>
                    <kendo-numerictextbox formControlName="pinAng" id="rcPinAng"
                        [decimals]="3" format="n3" [min]="0" [step]="0.001"
                        [inputAttributes]="inputModeDecimal"
                        [readonly]="readonly" [spinners]="!readonly"></kendo-numerictextbox>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="rcOffsetNum">Offset</kendo-label>
                    <kendo-numerictextbox formControlName="offsetNum" id="rcOffsetNum"
                        [decimals]="3" format="n3" [min]="0" [step]="0.001"
                        [inputAttributes]="inputModeDecimal"
                        [readonly]="readonly" [spinners]="!readonly"></kendo-numerictextbox>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="rcBkfc">BKFC</kendo-label>
                    <kendo-numerictextbox formControlName="bkfc" id="rcBkfc"
                        [decimals]="3" format="n3" [min]="0" [step]="0.001"
                        [inputAttributes]="inputModeDecimal"
                        [readonly]="readonly" [spinners]="!readonly"></kendo-numerictextbox>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="rcSurfDiamond">Surf Diamond</kendo-label>
                    <kendo-numerictextbox formControlName="surfDiamond" id="rcSurfDiamond"
                        [decimals]="3" format="n3" [min]="0" [step]="0.001"
                        [inputAttributes]="inputModeDecimal"
                        [readonly]="readonly" [spinners]="!readonly"></kendo-numerictextbox>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="rcLayout">Layout</kendo-label>
                    <kendo-numerictextbox formControlName="layout" id="rcLayout"
                        [decimals]="0" format="n0" [min]="0" [step]="1"
                        [readonly]="readonly" [spinners]="!readonly"></kendo-numerictextbox>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="rcArm">Arm</kendo-label>
                    <kendo-numerictextbox formControlName="arm" id="rcArm"
                        [decimals]="0" format="n0" [min]="0" [step]="1"
                        [readonly]="readonly" [spinners]="!readonly"></kendo-numerictextbox>
                </kendo-formfield>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="rcReferenceLayout">Reference Layout</kendo-label>
                    <kendo-numerictextbox formControlName="referenceLayout" id="rcReferenceLayout"
                        [decimals]="0" format="n0" [min]="0" [step]="1"
                        [readonly]="readonly" [spinners]="!readonly"></kendo-numerictextbox>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="rcReferenceArm">Reference Arm</kendo-label>
                    <kendo-numerictextbox formControlName="referenceArm" id="rcReferenceArm"
                        [decimals]="0" format="n0" [min]="0" [step]="1"
                        [readonly]="readonly" [spinners]="!readonly"></kendo-numerictextbox>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="rcTechBit">Tech Bit</kendo-label>
                    <kendo-dropdownlist formControlName="techBit" id="rcTechBit"
                        [data]="yesno" textField="name" valueField="value"
                        [valuePrimitive]="true" [readonly]="readonly">
                    </kendo-dropdownlist>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="rcFaiRequired">FAI Required</kendo-label>
                    <kendo-dropdownlist formControlName="faiRequired" id="rcFaiRequired"
                        [data]="yesno" textField="name" valueField="value"
                        [valuePrimitive]="true" [readonly]="readonly">
                    </kendo-dropdownlist>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="rcAdero">Adero</kendo-label>
                    <kendo-dropdownlist formControlName="adero" id="rcAdero"
                        [data]="yesno" textField="name" valueField="value"
                        [valuePrimitive]="true" [readonly]="readonly">
                    </kendo-dropdownlist>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="rcNewCone">New Cone</kendo-label>
                    <kendo-dropdownlist formControlName="newCone" id="rcNewCone"
                        [data]="yesno" textField="name" valueField="value"
                        [valuePrimitive]="true" [readonly]="readonly">
                    </kendo-dropdownlist>
                </kendo-formfield>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="rcNewArm">New Arm</kendo-label>
                    <kendo-dropdownlist formControlName="newArm" id="rcNewArm"
                        [data]="yesno" textField="name" valueField="value"
                        [valuePrimitive]="true" [readonly]="readonly">
                    </kendo-dropdownlist>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-5">
                <kendo-formfield>
                    <kendo-label for="rcRetrofitFeature">Retrofit Feature</kendo-label>
                    <kendo-textbox formControlName="retrofitFeature" id="rcRetrofitFeature"
                        [readonly]="readonly"></kendo-textbox>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-3">
                <kendo-formfield>
                    <kendo-label for="rcRetrofitType">Retrofit Type</kendo-label>
                    <kendo-textbox formControlName="retrofitType" id="rcRetrofitType"
                        [readonly]="readonly"></kendo-textbox>
                </kendo-formfield>
            </div>
        </div>
    </fieldset>
</ng-form>
